import { Dices } from "lucide-react";
import { Link } from "react-router-dom";

export function HighwayBanner() {
  return (
    <section className="highway-banner rb-glitch" data-testid="highway-banner">
      <img loading="lazy"
        className="highway-banner-art"
        src="/assets/dolosway-banner.webp"
        alt="Dolosway — the digital board game key art, dice on glowing hex tiles in a ruined city"
      />
      <img className="rb-glitch-copy rb-glitch-a" src="/assets/dolosway-banner.webp" alt="" aria-hidden="true" />
      <img className="rb-glitch-copy rb-glitch-b" src="/assets/dolosway-banner.webp" alt="" aria-hidden="true" />
      <div className="highway-banner-ui">
        <span className="highway-banner-tag">NEW BOARD GAME // FIVE RUNNERS ENTER</span>
        <Link to="/wasteland-radio" className="highway-banner-cta" data-testid="highway-play-now">
          <Dices size={18} /> PLAY NOW
        </Link>
      </div>
    </section>
  );
}
